import { ValidatorFn, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';

export const TimeValidator: ValidatorFn = (fg: UntypedFormGroup) => {
    const currentDate = fg.get('eventDate').value;
    const now = parseFloat(moment().format('HH.mm'));
    const start = fg.get('eventStartTime').value ? parseFloat(fg.get('eventStartTime').value.replace(':', '.')) : null;
    const end = fg.get('eventEndTime').value ? parseFloat(fg.get('eventEndTime').value.replace(':', '.')) : null;
    if (moment().isSame(moment(new Date(currentDate.year, currentDate.month - 1, currentDate.day)), 'date')) {
        return start !== null && end !== null && start < end && start >= now && end >= now
            ? null
            : { timeNotValid: true };
    }
    return start !== null && end !== null && start < end ? null : { timeNotValid: true };
};
